import { map } from 'lodash';
import { DocType } from '../global/Doc.enum';
import Root from '../Root';
import type { IDashboard } from './Dashboard.interface';
import DashboardItem from './DashboardItem';

export default class Dashboard extends Root implements IDashboard {
  name: string;
  items: Array<DashboardItem>;

  getName() {
    return this.name;
  }

  static build = (data: IDashboard) => new Dashboard(data);
  static blank = () => new Dashboard({ isActive: true });

  /**
   * Constructor
   * @param {IDashboard} data
   */
  constructor(data?: IDashboard) {
    super(DocType.of('__definition.dashboard'), data);

    this.name = data?.name || '';
    this.items = map(data?.items, (obj) => new DashboardItem(obj));
  }
}
